import videoUtils from "../custom/video-utils"; // Ensure the path is correct

const gridVideo = () => {

    const videoBlocks = document.querySelectorAll(".block-grid-video");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const block = entry.target;
                initializeVideoBlock(block);
                observer.unobserve(block); // Unobserve after initialization
            }
        });
    });

    videoBlocks.forEach((block) => observer.observe(block));
};

// Initialize a single video block
const initializeVideoBlock = (block) => {
    const playButton = block.querySelector(".play-button");
    const videoWrapper = block.querySelector(".video-wrapper");
    const video = videoWrapper.querySelector("video");
    const iframe = videoWrapper.querySelector("iframe");
    const caption = block.querySelector("figcaption");
    const overlay = block.querySelector(".overlay");

    // Set lazy loading for iframe
    if (iframe){
		iframe.setAttribute("loading", "lazy");
	}

    // Play Video Handler
    const playVideo = async () => {

        playButton.classList.add("active");
        caption.classList.add("active");
        overlay.classList.remove("visible");

        if (video) {
            playHTML5Video(video);
			video.style.aspectRatio = "16/9";

        } else if (iframe) {

            iframe.classList.add("visible");
			iframe.style.aspectRatio = "16/9";

            if (iframe.src.includes("vimeo.com")) {
                await videoUtils.playAndControlVimeo(iframe);
            } else if (iframe.src.includes("youtube.com")) {
                await videoUtils.playYouTube(iframe, {
                    onStateChange: (event) => handleYouTubeStateChange(event, overlay),
                });
            }
        }
    };

    // Attach event listeners
    playButton.addEventListener("click", playVideo);
    overlay.addEventListener("click", playVideo);

    // Setup events for HTML5 video
    if (video) setupHTML5VideoEvents(video, overlay);
};

// Play HTML5 Video
const playHTML5Video = (video) => {
    video.setAttribute("controls", "controls");
    video.classList.add("is-playing");
	video.classList.add("visible");
    video.play();
    videoUtils.pushVideoEventToDataLayer("play", "HTML5", video.currentSrc);
};

// Handle YouTube Player State Changes
const handleYouTubeStateChange = (event, overlay) => {
    const iframeSrc = event.target.getIframe().src;

    switch (event.data) {
        case YT.PlayerState.PAUSED:
            videoUtils.pushVideoEventToDataLayer("pause", "YouTube", iframeSrc);
            break;
        case YT.PlayerState.ENDED:
            videoUtils.pushVideoEventToDataLayer("end", "YouTube", iframeSrc);
            overlay.classList.add("visible");
            break;
    }
};

// Setup HTML5 Video Event Listeners
const setupHTML5VideoEvents = (video, overlay) => {
    video.addEventListener("play", () => {
        videoUtils.pushVideoEventToDataLayer("play", "HTML5", video.currentSrc);
    });

    video.addEventListener("pause", () => {
        videoUtils.pushVideoEventToDataLayer("pause", "HTML5", video.currentSrc);
    });

    video.addEventListener("ended", () => {
        videoUtils.pushVideoEventToDataLayer("end", "HTML5", video.currentSrc);
        overlay.classList.add("visible");
    });

	video.addEventListener("volumechange", () => {
		const isMuted = video.muted; // Check if the video is muted
		const eventAction = isMuted ? "mute" : "unmute";
		// Push the event to the GTM data layer
		videoUtils.pushVideoEventToDataLayer(eventAction, "HTML5", video.currentSrc);
	});

    videoUtils.setupProgressTracking({
        type: "HTML5",
        element: video,
        source: video.currentSrc,
    });
};

// Preload the first video for better LCP
const preloadFirstVideo = () => {

    document.querySelectorAll(".copy-image-video__media-video:first-of-type video, .copy-image-video__media-video:first-of-type iframe").forEach((element) => {

		let videoSrc = "";

        if (element.tagName === "VIDEO") {
            const source = element.querySelector("source");
            if (source) {
                videoSrc = source.src; // Get src from <source>
            } else {
                videoSrc = element.src; // Fallback to video src
            }
        } else if (element.tagName === "IFRAME") {
            videoSrc = element.src; // Get iframe src
        }
        if (videoSrc) {
            const preloadLink = document.createElement("link");
            preloadLink.rel = "preload";
			preloadLink.as = "fetch";
            preloadLink.href = videoSrc;
            document.head.appendChild(preloadLink);
        }
    });
};

// Initialize blockVideo on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
    preloadFirstVideo();
    gridVideo();
});
